import { ContentBox } from "@msuite/ui/content-box";
import { TransferCarriersTable } from "@/components/stock/transfer-carriers-table";
import { TransferCarriersMenu } from "./transfer-carriers-menu";

export function TransferCarriers() {
	/** Render */
	return (
		<ContentBox>
			<TransferCarriersTable
				menu={<TransferCarriersMenu />}
				variant="table"
			/>
		</ContentBox>
	);
}
